// frontend/src/components/handbook/ContentTypeBadge.js
import React from "react";
import { CheckSquare, BookOpen, Layers } from "lucide-react";

const TYPE_META = {
  operational: {
    label: "Daily",
    title: "Operationelle Checkliste — wird vor jedem Camp erneut durchgegangen",
    Icon: CheckSquare,
    className: "bg-[#84BD00]/10 text-[#5a8200] border-[#84BD00]/30",
  },
  reference: {
    label: "Lesen",
    title: "Hintergrundwissen — einmal lesen reicht",
    Icon: BookOpen,
    className: "bg-[#00A3E0]/10 text-[#0078a8] border-[#00A3E0]/30",
  },
  mixed: {
    label: "Misch",
    title: "Hintergrund + Checkliste",
    Icon: Layers,
    className: "bg-gray-100 text-gray-600 border-gray-200",
  },
};

const ContentTypeBadge = ({ type, compact = false, className = "" }) => {
  const meta = TYPE_META[type] || TYPE_META.mixed;
  const { Icon } = meta;

  if (compact) {
    return (
      <span
        title={meta.title}
        className={`inline-flex items-center justify-center w-5 h-5 rounded ${meta.className} ${className}`}
      >
        <Icon className="w-3 h-3" />
      </span>
    );
  }

  return (
    <span
      title={meta.title}
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-semibold uppercase tracking-wide border ${meta.className} ${className}`}
    >
      <Icon className="w-3 h-3" />
      {meta.label}
    </span>
  );
};

export default ContentTypeBadge;
